export const REPORTS_ACTION = {
    RESET_REPORTS_PROJECTS_STATE: 'RESET_REPORTS_PROJECT_STATE',
    REQUEST_REPORTS_PROJECTS: 'REQUEST_REPORTS_PROJECTS',
    RESPONSE_REPORTS_PROJECTS: 'RESPONSE_REPORTS_PROJECTS',
    ERROR_REPORTS_PROJECTS: 'ERROR_REPORTS_PROJECTS',

    RESET_GENERATE_REPORT_STATE: 'RESET_GENERATE_REPORT_STATE',
    REQUEST_GENERATE_REPORT: 'REQUEST_GENERATE_REPORT',
    RESPONSE_GENERATE_REPORT: 'RESPONSE_GENERATE_REPORT',
    ERROR_GENERATE_REPORT: 'ERROR_GENERATE_REPORT',

    RESET_BUDGET_REPORTS_STATE: 'RESET_BUDGET_REPORTS_STATE',
    REQUEST_BUDGET_REPORTS: 'REQUEST_BUDGET_REPORTS',
    RESPONSE_BUDGET_REPORTS: 'RESPONSE_BUDGET_REPORTS',
    ERROR_BUDGET_REPORTS: 'ERROR_BUDGET_REPORTS',

  };

  export const setResetStateReportsProjects = () => ({
    type: REPORTS_ACTION.RESET_REPORTS_PROJECTS_STATE,
    data: undefined
  });

  export const requestReportsProjects = (params) => ({
    type: REPORTS_ACTION.REQUEST_REPORTS_PROJECTS,
    data: params 
  });

  export const responseReportsProjects = (res) => ({
    type: REPORTS_ACTION.RESPONSE_REPORTS_PROJECTS,
    data: res
  });

  export const errorReportsProjects = (err) => ({
    type: REPORTS_ACTION.ERROR_REPORTS_PROJECTS,
    data: err
  });

  
  export const setResetStateGenerateReport = () => ({
    type: REPORTS_ACTION.RESET_GENERATE_REPORT_STATE,
    data: undefined
  });

  export const requestGenerateReport = (params) => ({
    type: REPORTS_ACTION.REQUEST_GENERATE_REPORT,
    data: params 
  });

  export const responseGenerateReport = (res) => ({
    type: REPORTS_ACTION.RESPONSE_GENERATE_REPORT,
    data: res
  });

  export const errorGenerateReport = (err) => ({
    type: REPORTS_ACTION.ERROR_GENERATE_REPORT,
    data: err
  });

  export const setResetStateBudgetReport = () => ({
    type: REPORTS_ACTION.RESET_BUDGET_REPORTS_STATE,
    data: undefined
  });

  export const requestBudgetReport = (params) => ({
    type: REPORTS_ACTION.REQUEST_BUDGET_REPORTS,
    data: params 
  });

  export const responseBudgetReport = (res) => ({
    type: REPORTS_ACTION.RESPONSE_BUDGET_REPORTS,
    data: res
  });

  export const errorBudgetReport = (err) => ({
    type: REPORTS_ACTION.ERROR_BUDGET_REPORTS,
    data: err
  });
  
